import { IMAGES } from "@/data/services";
import { Reveal, Eyebrow } from "@/components/Reveal";
import CTABand from "@/components/CTABand";
import Seo from "@/components/Seo";

export default function About() {
  return (
    <div data-testid="about-page">
      <Seo
        title="About Legacy Scapes Ltd, 7 Plus Years in the St. Clair Corridor"
        description="Learn about Legacy Scapes Ltd, an established lawn care and landscaping company serving the St. Clair Corridor for over 7 years."
      />

      <section className="bg-[#F4F6F3] pt-[76px]">
        <div className="mx-auto max-w-[1160px] px-5 py-16 md:px-8 md:py-24">
          <Reveal>
            <Eyebrow>About us</Eyebrow>
            <h1 className="mt-4 max-w-3xl text-4xl font-extrabold leading-[1.08] tracking-tight text-[#16241C] sm:text-5xl" data-testid="about-headline">
              Built on Reliability
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto grid max-w-[1160px] items-center gap-12 px-5 py-16 md:px-8 md:py-24 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="overflow-hidden rounded-2xl">
              <img src={IMAGES.about} alt="A Legacy Scapes crew member at work" loading="lazy" className="aspect-[4/3] w-full object-cover" />
            </div>
          </Reveal>
          <div>
            <Reveal>
              <div className="space-y-4 text-base leading-[1.7] text-[#5B6B60]">
                <p>
                  Legacy Scapes has been operating in the St. Clair Corridor for over 7 years, and
                  in that time we've completed more than 3,000 jobs for homeowners, commercial
                  properties, and property management companies across the region. We're not a one
                  truck operation. We run established crews with leads and foremen in place, and we
                  treat every account, residential or commercial, with the same level of structure
                  and follow through.
                </p>
                <p>
                  Our name is intentional. Legacy reflects how we want to be known across the
                  corridor, a company that's built to last, that does things the right way, and that
                  clients can depend on year after year.
                </p>
                <p>
                  Over the next few years, we're growing in two directions at once, continuing to
                  build our residential subscription service, and expanding into larger commercial
                  and industrial accounts across the corridor. Wherever you find us, you'll find
                  the same standard.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand heading="Want to Work With Us?" />
    </div>
  );
}
